import {
  Directive,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Subject, fromEvent } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

const MOBILE_VIEW_THRESHOULD = 768;

@Directive({
  selector: "[mobile]",
})
export class MobileDirective implements OnDestroy, OnInit {
  private destroyed$: Subject<boolean> = new Subject();

  @Output() mobileView: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      this._emitMobileStatus();
    }, 100);

    fromEvent(window, "resize")
      .pipe(debounceTime(100), takeUntil(this.destroyed$))
      .subscribe(() => {
        this._emitMobileStatus();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private _emitMobileStatus() {
    this.mobileView.emit(document.body.clientWidth < MOBILE_VIEW_THRESHOULD);
  }
}
